import React, {Component} from 'react';
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import LocalDayOfWeek from '../LocalDayOfWeek'
import {minutesToHuman} from '../../Helpers'
import AttivitaGiornoColored from './AttivitaGiornoColored'
import Moment from 'moment'
import PropTypes from 'prop-types';
class AttivitaGiorniPrecedentiColored extends Component {

    constructor(props) {
        super(props);
        this.state = {
            _loading: false,
            error: null,
            items: []
        };
        this.oggi = Moment().format('YYYY-MM-DD');
        this.loadData = this.loadData.bind(this)
        this.renderOnClickGiorno = this.renderOnClickGiorno.bind(this)
    }

    componentDidMount() {
        this.loadData(this.props.giorno);
    }

    componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.giorno !== this.props.giorno){
            this.loadData(nextProps.giorno)
        }
    }

    loadData(giorno) {

        if (giorno === undefined) return;

        this.setState({_loading: true});
        client.loadStatsPrevdays(this.props.idUtente,
            giorno, //Moment(giorno).add(1, 'days').format('YYYY-MM-DD'),
            this.props.numgg).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{

                    this.setState({
                        items: data.items,
                        attPerDay: data.attPerDay,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    renderOnClickGiorno(giorno){
        let giornoCnt = <LocalDayOfWeek data={giorno} />;
        if (giorno === this.oggi){
          giornoCnt = "Oggi";
        }
        if (this.props.onClickGiorno !== undefined){
            return <a href="#" onClick={(ev) => this.props.onClickGiorno(giorno)}>{giornoCnt}</a>
        }
        else
        {
            return {giornoCnt}
        }
    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }


        let attivitaList =  this.state.items.map((item, index, arr) => {

            let attList = this.state.attPerDay[item.giorno];
            return (<tr key={item.giorno}>
                    <td className="collapsing left aligned">
                        {item.attivitaDaCompletare ? <label className="ui medium red circular label" title="In questo giorno ci sono delle attività registrate ma non ancora completate">!</label> : null} {this.renderOnClickGiorno(item.giorno)}
                    </td>
                    <td className="collapsing right aligned" title="durata in ore:minuti">
                        {minutesToHuman(item.minutiTotali)}
                    </td>
                    <td>
                        <AttivitaGiornoColored
                            item={item}
                            attivitaList={attList}
                            canvasRowHeight={this.props.canvasRowHeight}
                        />
                    </td>
                </tr>
            )
        });

        if (this.state.items.length <= 0){
            attivitaList = <table className="ui table">
                    <tbody><tr><td><h3>Nessun dato disponibile</h3></td></tr></tbody></table>
        }
        else {
            attivitaList = <table className="ui table">
                <tbody>
                {attivitaList}
                </tbody>
            </table>;
        }

        return (<div>
            {attivitaList}
            {loader}
        </div>)
    }
}

AttivitaGiorniPrecedentiColored.PropTypes = {
    giorno: PropTypes.string.isRequired,
    numgg: PropTypes.number.isRequired,
    idUtente: PropTypes.number.isRequired,
    canvasRowHeight: PropTypes.number,
    onClickGiorno: PropTypes.func,
}

AttivitaGiorniPrecedentiColored.defaultProps = {
    canvasRowHeight: 30,
    numgg: 0,
}
export default AttivitaGiorniPrecedentiColored;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaGiorniPrecedentiColored.js
 **/